import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import {
  FormEmail,
} from '@uncinc/uncinc-react-kitchen-sink';

import Button from '../../Button';
import CheckAll from '../../CheckAll';

export interface SearchOcularExportProps {
  isLoading: boolean;
  className?: string;
  setExportType: (arg0: 'export_images' | 'request_metadata') => void;
}

import './style.scss';

const SearchOcularExport: React.FC<SearchOcularExportProps> = (props) => {
  const { className, isLoading, setExportType } = props;
  const { t } = useTranslation();
  const classNames = c('SearchOcularDB__Export', className);

  return (
    <div className={classNames}>
      <CheckAll />
      <h3>{t('components.search_oculardb.export.heading')}</h3>
      <div className="SearchOcularDB__Export__Images">
        <h4 className="SearchOcularDB__Export__title">{t('components.search_oculardb.export.title')}</h4>

        <FormEmail
          title={t('components.search_oculardb.export.email')}
          fieldName="email"
          placeholder={t('components.search_oculardb.export.email')}
        />

        <Button
          className="SearchAllContent__Export__submit"
          type="secondary"
          htmlType="submit"
          loading={isLoading}
          onClick={() => {
            setExportType('export_images');
          }}
        >
          {t('components.export.export')} <span className="loader">⏳</span>
        </Button>
      </div>
      <div className="SearchOcularDB__Export__Metadata">
        <h4 className="SearchOcularDB__Export__title">{t('components.search_oculardb.export.metadata_title')}</h4>
        <Button
          className="SearchAllContent__Export__submit"
          type="secondary"
          htmlType="submit"
          loading={isLoading}
          onClick={() => {
            setExportType('request_metadata');
          }}
        >
          {t('components.export.request_metadata')} <span className="loader">⏳</span>
        </Button>
      </div>

    </div>
  );
};

export default SearchOcularExport;
